// extracted by mini-css-extract-plugin
export var clickableWrapper = "_2k-2";
export var placeholderIcon = "_2k-3";
export var thumbnailCanvas = "_2k-1";
export var thumbnailWrapper = "_2k-0";